import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NewsroomComponent } from './components/Newsroom/newsroom.component';
import { StoriesComponent } from './components/stories/stories.component';
import { StoryComponent } from './components/story/story.component';
import { StoryApiModule } from '../../api/story/story-api.module';
import { SubjectApiModule} from '../../api/subject/subject-api.module';
import { TooltipModule } from 'primeng/tooltip';
import { TableModule } from 'primeng/table';
import { RouterModule } from '@angular/router';
import { NewsroomRoutingModule } from './newsroom-routing.module';
import { CanDeactivateGuard } from './services/can-deactivate-guard.service';
import { StoryDetailResolver } from './services/story-resolver.service';
import { UniqueIDService } from '../../Common/Misc/services/unique-id.service';
import { CookieService } from 'ngx-cookie-service';
import { NewsroomRightSideBarComponent } from './components/NewsroomRightSideBar/newsroom-right-side-bar.component';
import { Story } from './services/story.service';
import { NotifyToStoryService } from './services/notify-to-story.service';
import { SelectModule } from 'primeng/select';
import { CommonDialogsModule } from '../../Common/Dialogs/common-dialogs.module';
import { CommonFormsModule } from '../../Common/Forms/forms.module';
import { MiscModule } from '../../Common/Misc/misc.module';
import { NewsSharedModule } from '../Shared/news-shared.module';
import { CommonBasicModule } from '../../Common/Basic/basic.module';
import { LayoutModule } from '../../Common/Layout/layout.module';
import { NewsroomLeftSidebarService } from './services/newsroom-left-sidebar.service';

@NgModule({ declarations: [
        NewsroomComponent,
        StoriesComponent,
        StoryComponent,
        NewsroomRightSideBarComponent
    ],
    exports: [
        NewsroomComponent,
        StoryComponent,
        NewsroomRightSideBarComponent
    ], imports: [CommonModule,
        FormsModule,
        StoryApiModule,
        MiscModule,
        CommonDialogsModule,
        SubjectApiModule,
        ReactiveFormsModule,
        CommonFormsModule,
        TooltipModule,
        TableModule,
        RouterModule,
        NewsroomRoutingModule,
        SelectModule,
        NewsSharedModule,
        CommonBasicModule,
        LayoutModule], providers: [
        CanDeactivateGuard,
        StoryDetailResolver,
        UniqueIDService,
        CookieService,
        NotifyToStoryService,
        Story,
        NewsroomLeftSidebarService,
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class NewsroomModule {
}
